import { render } from "./ShowFinally.vue?vue&type=template&id=a085c30a&ts=true"
import script from "./ShowFinally.vue?vue&type=script&lang=ts"
export * from "./ShowFinally.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__